module.exports = __webpack_public_path__ + "logos/intento-brain.9e7a1683.svg";


//////////////////
// WEBPACK FOOTER
// /usr/src/app/frontend/src/assets/intento-brain.svg
// module id = 629
// module chunks = 3 5 7